'use client';

import { TrackedButton } from '@/components/button/tracked-button';
import { TEN_YEARS_POSITION } from '../_const/stories';
import { ChevronIcon } from '@/components/icons/chevron-icons';

/** 양 끝에서는 disabled 대신 aria-disabled — 끝에 닿아도 포커스가 버튼에 남는다. 크기는 모바일 36 / 데스크탑 48 */
export default function ChevronButton({
  direction,
  label,
  trackLabel,
  disabled,
  onClick,
}: {
  direction: 'prev' | 'next';
  // 접근 이름
  label: string;
  // gtag 라벨
  trackLabel: string;
  disabled: boolean;
  onClick?: () => void;
}) {
  return (
    <TrackedButton
      type="button"
      label={trackLabel}
      position={TEN_YEARS_POSITION}
      aria-label={label}
      aria-disabled={disabled}
      onClick={() => !disabled && onClick?.()}
      className="flex size-9 items-center justify-center rounded-full bg-3b-background-medium text-3b-text-primary transition-opacity aria-disabled:cursor-default aria-disabled:opacity-40 lg:size-12"
    >
      <ChevronIcon
        direction={direction === 'prev' ? 'left' : 'right'}
        className="size-5 lg:size-6"
      />
    </TrackedButton>
  );
}
